// Shared role helpers.
//
// "admin" and "tester" are privileged roles used to QA the courses: they bypass
// payment/subscription route gating, see every lesson unlocked in the table of
// contents, and get a "Mark lesson complete" shortcut in the lesson HUD.
// Privilege is trusted client-side only (same model as the original admin
// bypass) — the backend does not enforce roles per-endpoint.
export const isPrivilegedRole = (role) => role === "admin" || role === "tester";

// Standard (non-privileged) learner roles.
//
// "user" is what sign-up writes; "codenec-user-client" is the same access under
// a different label, assigned by hand on the Firestore users doc. Deliberately
// kept out of isPrivilegedRole — a client is a paying learner, not a QA account.
// Use this wherever the app affirmatively asks "is this an ordinary learner?"
// so new standard roles don't have to be chased through the codebase.
export const CLIENT_ROLE = "codenec-user-client";

export const isStandardUserRole = (role) => role === "user" || role === CLIENT_ROLE;

// Who may open "Mis recursos" (/resources): clients, plus admins and testers so
// the page can be QA'd without switching accounts. Deliberately NOT
// isStandardUserRole — a plain "user" is a course student, not a client, and
// must not see the menu item or reach the route by typing the URL.
export const canAccessResources = (role) =>
    role === CLIENT_ROLE || isPrivilegedRole(role);
